module.exports = "/img/_/_/_/assets/images/creeper/book/uncommon//8.jpg?608b5714cc00ce17a6167dd3904f0696";